export enum NatureOfAttendanceEnum {
    presencial = 1,
    online = 2
}